export default __webpack_public_path__ + "static/media/bmo.1a023f67.jpg";